"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formCoupler = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _assign2 = _interopRequireDefault(require("lodash/assign"));
var _cccisdFormik = require("cccisd-formik");
var _plusCircle = _interopRequireDefault(require("cccisd-icons/plus-circle2"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _helpers = require("../../helpers");
var _Certificate = _interopRequireDefault(require("../../../navigations/courseWrapper/Mediator/Certificate"));
var _FormikCertificate = _interopRequireDefault(require("./FormikCertificate.js"));
var _style = _interopRequireDefault(require("../style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var initialValues = {
  toggle: false,
  allowRenew: false,
  renewConfirmation: 'Are you sure? All progress will be reset, and you will be required to start all course content from the beginning. This includes any post-course tests and evaluations.',
  tabName: 'Certificate',
  completionText: '',
  certificates: [{
    backgroundId: null,
    courseName: '',
    freeText: '',
    dynamicAccreditation1: '',
    dynamicAccreditation2: '',
    dynamicAccreditation3: ''
  }]
};
var newCertificateValues = {
  backgroundId: null,
  courseName: '',
  freeText: '',
  accreditation1: '',
  accreditation2: '',
  accreditation3: ''
};
var validate = function validate(values, errors) {
  var localErrors = {};
  if (values.certificate.toggle) {
    if (!values.certificate.tabName) {
      localErrors['certificate.tabName'] = 'Tab Name is required';
    }
  }
  (0, _assign2["default"])(errors, localErrors);
  return !Object.keys(localErrors).length;
};
var formCoupler = exports.formCoupler = {
  initialValues: initialValues,
  validate: validate,
  errorTab: 'postCourse',
  key: 'certificate'
};
var FormCertificate = function FormCertificate(_ref) {
  var currentCertificates = _ref.currentCertificates,
    currentCompletionText = _ref.currentCompletionText,
    currentTabName = _ref.currentTabName,
    _ref$formProps = _ref.formProps,
    formProps = _ref$formProps === void 0 ? null : _ref$formProps,
    staticCertificateId = _ref.staticCertificateId,
    toggle = _ref.toggle;
  var renderToggleField = function renderToggleField() {
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "certificate.toggle",
      component: _cccisdFormik.CccisdToggle,
      label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
        label: "Use Certificate Tab",
        tooltip: "Show the Certificate tab once all requirements are complete?"
      })
    });
  };
  var renderPreview = function renderPreview() {
    return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      trigger: /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-secondary btn-info ".concat(_style["default"].fieldSpacing),
        type: "button"
      }, "Preview Certificate"),
      size: "large",
      title: "Certificate Preview"
    }, /*#__PURE__*/_react["default"].createElement(_Certificate["default"], {
      settings: {
        certificates: currentCertificates,
        completionText: currentCompletionText,
        staticCertificateId: staticCertificateId,
        tabName: currentTabName
      }
    }));
  };
  var renderConditionalFields = function renderConditionalFields() {
    var _formProps$values, _formProps$values$cer;
    return (
      /*#__PURE__*/
      // noScrollX prevents wysiwyg from creating tiny glitchy scrollbar
      _react["default"].createElement("div", {
        className: _style["default"].noScrollX
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "certificate.tabName",
        component: _cccisdFormik.CccisdInput,
        label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
          label: "Certificate Tab Name",
          tooltip: "The text for Certificate in the tab bar"
        })
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "certificate.allowRenew",
        component: _cccisdFormik.CccisdToggle,
        label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
          label: "Allow users to renew certificate",
          tooltip: 'Allows users to reset their own course progress. ' + 'This should be ON in cases where users need to get new certificates every so often. ' + 'For example, when a user needs re-certified once per year. ' + 'Minimum repeat time interval can be set in Deployment settings.'
        })
      }), (formProps === null || formProps === void 0 ? void 0 : (_formProps$values = formProps.values) === null || _formProps$values === void 0 ? void 0 : (_formProps$values$cer = _formProps$values.certificate) === null || _formProps$values$cer === void 0 ? void 0 : _formProps$values$cer.allowRenew) && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "certificate.renewConfirmation",
        component: _cccisdFormik.CccisdWysiwyg,
        label: "Renew Certificate Confirmation Message",
        type: "textarea"
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "certificate.completionText",
        component: _cccisdFormik.CccisdWysiwyg,
        label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
          label: "Completion Text",
          tooltip: "Appears above Certificate"
        }),
        type: "textarea"
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.FieldArray, {
        name: "certificate.certificates",
        render: function render(arrayHelpers) {
          return /*#__PURE__*/_react["default"].createElement("div", null, formProps.values.certificate.certificates.map(function (c, i) {
            return /*#__PURE__*/_react["default"].createElement(_FormikCertificate["default"], {
              certificate: c,
              certificates: formProps.values.certificate.certificates,
              deleteCertificate: function deleteCertificate() {
                return arrayHelpers.remove(i);
              },
              index: i,
              key: i,
              name: "certificate.certificates[".concat(i, "]")
            });
          }), /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-secondary",
            onClick: function onClick() {
              return arrayHelpers.push(newCertificateValues);
            }
          }, /*#__PURE__*/_react["default"].createElement(_plusCircle["default"], null), " Add Certificate"));
        }
      }), renderPreview())
    );
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h3", null, "Certificate"), renderToggleField(), toggle && renderConditionalFields());
};
var _default = exports["default"] = FormCertificate;